import moment from 'moment';

import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import { getDefaultMarkBlockedValue } from '../../util/filterUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'FE_ERROR';
export const LOADING = 'FE_LOADING';
export const LOADING_DETAILS = 'FE_LOADING_DETAILS';
export const SUCCESS = 'FE_SUCCESS';
export const SUCCESS_DETAILS = 'FE_SUCCESS_DETAILS';
export const SUCCESS_AVG_DATA = 'FE_SUCCESS_AVG_DATA';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

function detailsIsLoading(bool) {
  return {
    type: LOADING_DETAILS,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

export function successDetails(data) {
  return {
    type: SUCCESS_DETAILS,
    data: data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { chart, allCustomFields, excludeWeekends, workStart, workEnd, holidays, enabledColors, dates } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : allFilters.fe;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let ctData = await worker.CycleTimeScatterPlot({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        color: true,
        markBlocked: filters.markBlocked && getDefaultMarkBlockedValue(data.app, selected)
      });
      dispatch(success(ctData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getDetailsData(dates) {
  return async (dispatch, getState) => {
    dispatch(detailsIsLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const { allCustomFields, excludeWeekends, workStart, workEnd, holidays, enabledColors, fe } = getState().filters;

    const customFields = customFieldsUtils.getSelected(allCustomFields, fe);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let feData = await worker.FlowEfficiency({
        lists: fe.selectedLists,
        queueLists: fe.selectedQueueLists,
        labels: fe.selectedLabels,
        members: fe.selectedMembers,
        chartType: fe.chartType,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        markBlocked: fe.markBlocked && getDefaultMarkBlockedValue(data.app, selected)
      });
      dispatch(successDetails(feData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function calculateAvgFe(data, reduxType) {
  return (dispatch, getState) => {
    const { selected } = getState().dashboards;
    const { chart, overview, fe, dates } = getState().filters;
    const filters = chart === 'overview' ? overview : fe;

    const queueLists = [].concat(filters.selectedQueueLists).map(l => l._id);
    const excludeLists = [].concat.apply([], [selected.todo, queueLists, selected.done]).map(l => l._id || l);
    const efficiencyRange = filters.effRange;
    const efficiencies = [];

    let from = moment(dates.startDate);
    let dataByMonths = {};
    const flatData = _(data)
      .flatMap(i => {
        return i.data;
      })
      .sortBy('x').value();
    while (from.isSameOrBefore(dates.endDate)) {
      dataByMonths[from.startOf('month')] = _.filter(flatData, i => {
        return from.isSame(moment(i.x), 'month');
      }) || [];
      from.add(1, 'month');
    }

    const feData = _(dataByMonths)
      .map((items, date) => {
        const dailyCards = _(items)
          .groupBy('card.id')
          .map(c => {
            let totalTime = _(c)
              .flatMap(i => {
                return i.details;
              })
              .reduce((acc, d) => {
                return acc + d.cycleTime;
              }, 0);

            let workTime = _(c)
              .flatMap(i => {
                return i.details;
              })
              .filter(d => {
                return _.indexOf(excludeLists, d.listId) === -1;
              })
              .reduce((acc, d) => {
                if (selected.isCsv && d.cycleTime < 1440) {
                  return acc + 1440;
                }
                return acc + d.cycleTime;
              }, 0);

            let activeBlockedTime = _(c)
              .flatMap(i => {
                return i.card.blockedLists;
              })
              .filter(l => {
                return _.indexOf(excludeLists, l.listId) === -1;
              })
              .reduce((acc, l) => {
                return acc + l.blockedTime;
              }, 0);

            let efficiency = 100;
            if (totalTime > 0) {
              if (selected.isCsv) {
                workTime = +moment.duration(workTime, 'minutes').format('d', { trim: 'mid both', useGrouping: false });
                activeBlockedTime = +moment.duration(activeBlockedTime, 'minutes').format('d', { trim: 'mid both', useGrouping: false });
                totalTime = +moment.duration(totalTime, 'minutes').format('d', { trim: 'mid both', useGrouping: false});
              }

              efficiency = ((workTime - activeBlockedTime) / totalTime) * 100;
              if (efficiency < 0) {
                efficiency = 0;
              }
            }

            if (efficiency > 100) {
              efficiency = 100;
            }

            return efficiency; //Math.round(efficiency);
          })
          .filter(e => {
            if (e >= efficiencyRange[0] && e <= efficiencyRange[1]) {
              efficiencies.push(e);
              return true;
            } else {
              return false;
            }
          })
          .value();

        const eff = _.reduce(
          dailyCards,
          (acc, d) => {
            return acc + d;
          },
          0
        );

        return {
          x: +moment.utc(new Date(date)).local(),
          y:  dailyCards.length > 0 ? Math.round((eff / dailyCards.length) * 100) / 100: 0
        };
      })
      .value();

    const total = _.reduce(
      efficiencies,
      (acc, d) => {
        return acc + d;
      },
      0
    );
    const avgFe = (total / efficiencies.length).toFixed(2);

    const avgData = {
      data: feData,
      avgFe: isNaN(avgFe) ? '0.00' : avgFe
    };

    if (reduxType) {
      dispatch({
        type: reduxType,
        data: avgData
      });
    }

    dispatch({
      type: SUCCESS_AVG_DATA,
      data: avgData
    });

    return avgData;
  };
}
